import React from "react";
import styled from "styled-components";
import Spinner from "../../../components/Spinner";
import { primaryColor } from "../../../constants/colors";

const AppointmentTypeSelector = ({ type, isOnlineVisible, isClinicVisible, onSelect }) => {
  return (
    <Wrapper className="px-3 py-2">
      <p className="txt">Appointment Type</p>
      <div className="d-flex gap-2 align-items-center appointmenttype">
        {isOnlineVisible && (
          <div className="d-flex flex-column">
            <div onClick={() => onSelect("Online")} className={`appointmenttype-item shadow-sm text-black fw-medium rounded-pill max-content d-flex py-2 px-3 ${type === "Online" ? "active" : ""}`}>
              <span style={{ textTransform: "capitalize" }}>{`Online`}</span>
            </div>
          </div>
        )}
        {isClinicVisible && (
          <div className="d-flex flex-column">
            <div onClick={() => onSelect("Clinic")} className={`appointmenttype-item shadow-sm text-black fw-medium rounded-pill max-content d-flex py-2 px-3 ${type === "Clinic" ? "active" : ""}`}>
              <span style={{ textTransform: "capitalize" }}>{`Clinic`}</span>
            </div>
          </div>
        )}
      </div>
    </Wrapper>
  );
};

export default AppointmentTypeSelector;

const Wrapper = styled.div`
  .appointmenttype {
    overflow-x: scroll;
  }
  .appointmenttype-item {
    background-color: #e9e9e9;
    white-space: nowrap;
    transition: all ease 0.3s;
    cursor: pointer;
    &.active {
      color: #fff !important;
      background-color: ${primaryColor};
    }
  }
  .appointmenttype::-webkit-scrollbar {
    display: none;
  }
  .txt {
    color: #9e9e9e;
  }
  .text-green {
    color: #00c033;
    font-size: 0.7rem;
  }
  p {
    margin-bottom: 0.4rem;
  }
`;
